// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();

jQuery(document).ready(function($) {

    $('.gf_login_links a:first-of-type').on('click', function(e) {
        e.preventDefault();

		$('.user-login').hide()
		$('.user-register').show();
    });

	$('.login-view a').on('click', function(e) {
        e.preventDefault();

		$('.user-login').show()
		$('.user-register').hide();
    });

	$('.dropdown-menu li:nth-of-type(5), .dropdown-menu li:nth-of-type(6), .dropdown-menu li:nth-of-type(7)').wrapAll('<div class="nav-last-three"></div>');

	// related products slider
    $('.related-products-wrap .products').slick({
        arrows: true,
        dots: true,
        autoplay: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                slidesToShow: 2
			},
            },
            {
                breakpoint: 900,
                settings: {
				slidesToShow: 2
			},
            }
        ]
    });

	if ( $(window).width() <= 768 ) {
		$('#footer .menu-item-has-children a').on('click', function(e) {
			e.preventDefault();
			$(this).parent().find('.dropdown-menu').toggle();
		});

		$('#footer .dropdown-menu a').on('click', function(e) {
			var page = $(this).attr('href');
			// console.log(page)
			window.location.href = page;
		});

		$('.translate-drop').insertAfter('.mobile-search');
	}

	$('.nav-last-three li a').on('mouseenter', function() {
		$(this).css({
			'background': 'transparent',
			'color': '#000'
		})
	});

	$('.nav-last-three li a').on('mouseleave', function() {
		$(this).css({
			'background': 'transparent',
			'color': '#0f4875'
		})
	});

	$('.navbar-toggler').on('click', function() {
		$('body').css('overflow', 'hidden');
	});

	$('.mobile-close').on('click', function() {
		$('.navbar-collapse').removeClass('show');
		$('body').css('overflow', 'visible');
	});

	var count = 0;
	var checkFilters = $('#wf-product-filter > div').children();

	checkFilters.each(function(i, e) {
		if ($(e).hasClass('hide')) {
			count++;
		}

		if (count === checkFilters.length) {
			// $('#reset-filters').hide();
		}
	});

	var mobileTexts = $('#menu-main .dropdown-menu li a p')
	
	if ($(window).width() <= 768) {
		mobileTexts.each(function(i, e) {
			$(this).insertAfter($(this).parent());
		});
	}

	//account ID used in checkout
    if ($('body.woocommerce-checkout').length && $('.woocommerce-additional-fields__field-wrapper #account_number_field').length) {
		let accountNumber = $('p.account-number span#account-id').text();
		if (accountNumber && accountNumber.length) {
			$('#account_number').val(accountNumber);
			console.log('Account number set:', accountNumber);
		}		
	}

});